import { Stack, Typography } from '@mui/material';

export const MemberEmpty = () => {
    return (
        <Stack justifyContent="center" alignItems="center" gap={3}>
            <img src="./img/not-found.png" alt="No member found" />
            <Stack gap={0} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    No member found
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    gutterBottom
                >
                    It seems your member list is empty.
                </Typography>
            </Stack>
        </Stack>
    );
};
